module.exports = __webpack_public_path__ + "img/bot-right-bg-mobile.839bb0e9.png";